import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
const ViewChatCell = React.memo(({ guid, onClick, t }) => {
    const handleClick = React.useCallback(() => {
        onClick(guid);
    }, [guid, onClick]);

    return (<Button variant="light-primary" size="xs" onClick={handleClick} title={t("viewContent")}>
        <FontAwesomeIcon icon={duotone('eye')} />
    </Button>);
});

export default ViewChatCell;